import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-spring-lightbox';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';

import LightBoxHeader from './LightBoxComponents/LightBoxHeader';
import styles from './LightBoxComponent.css';


function LightBoxComponent(props) {
  const {
    accessLevel,
    currentIndex,
    deletePic,
    gotoNext,
    gotoPrevious,
    images,
    onClose,
  } = props;

  const canDelete = accessLevel >= ACCESS_LEVEL_NUM.USER_MODERATOR;

  const renderHeader = useCallback(() => {
    const imageId = images?.[currentIndex]?.imageId;

    return (
      <LightBoxHeader
        close={onClose}
        deletePic={deletePic}
        imageId={imageId}
        isDeleteAvailable={canDelete}
      />
    );
  }, [canDelete, currentIndex, deletePic, images, onClose]);

  const renderNextButton = useCallback(({ canNext }) => (
    <ChevronRightIcon
      className={styles.next}
      disabled={!canNext}
      onClick={canNext ? gotoNext : null}
    />
  ), [gotoNext]);

  const renderPrevButton = useCallback(({ canPrev }) => (
    <ChevronLeftIcon
      className={styles.prev}
      disabled={!canPrev}
      onClick={canPrev ? gotoPrevious : null}
    />
  ), [gotoPrevious]);

  return (
    <Lightbox
      {...props}
      className={styles.imageLightBox}
      renderHeader={renderHeader}
      renderNextButton={renderNextButton}
      renderPrevButton={renderPrevButton}
      onNext={gotoNext}
      onPrev={gotoPrevious}
    />
  );
}

LightBoxComponent.propTypes = {
  onClose: PropTypes.func.isRequired,
  accessLevel: PropTypes.number,
  canDelete: PropTypes.bool,
  currentIndex: PropTypes.number,
  deletePic: PropTypes.func,
  gotoNext: PropTypes.func,
  gotoPrevious: PropTypes.func,
  images: PropTypes.array,
};

LightBoxComponent.defaultProps = {
  accessLevel: undefined,
  canDelete: false,
  currentIndex: undefined,
  deletePic: () => undefined,
  gotoNext: () => undefined,
  gotoPrevious: () => undefined,
  images: undefined,
};

export default LightBoxComponent;
